<template lang="pug">
.v-card-banner.card-banner(v-if="data" :id="data?.id")
	.card-banner__inner(:style="{backgroundImage: `url('${isTablet ? data.backgroundImage.mobile : data.backgroundImage.desktop}')`}")
		.card-banner__content
			img.card-banner__image(v-if="data.image" :src="data.image.src" :alt="data.image.alt")
			.card-banner__title(v-if="data.title" v-html="data.title")
			.card-banner__text(v-if="data.text" v-html="data.text")
			.card-banner__items(v-if="data.items")
				v-action.card-banner__item(v-for="item in data.items" :action="item" :class="{'card-banner__item--active': item.active}")
					template(#icon)
						img.card-banner__item-img(v-if="item.icon" :src="item.icon")
					v-svg-icon.card-banner__item-icon(icon="tik")
			a.card-banner__action.btn.btn--primary(v-if="data.action && !isTablet" :href="data.action.link ?? activeItem.link") {{data.action.text}}
	a.card-banner__action.btn.btn--primary(v-if="data.action && isTablet" :href="data.action.link ?? activeItem.link") {{data.action.text}}
</template>

<script>

import sourceMixin from "../components/mixins/v-mixin-source.vue";
import isMobMixin from "../components/mixins/v-mixin-is-mob.vue";

export default {
	mixins: [
		sourceMixin,
		isMobMixin
	],

	data() {
		return {
			data: null
		}
	},

	methods: {
		dataSet(data) {
			this.data = data;
		}
	}
}

</script>